import { AbstractControl, FormGroup } from "@angular/forms";
import { Cliente } from "src/app/modules/painel/modules/clientes/interfaces/cliente";
import { Endereco } from "src/app/modules/painel/modules/clientes/interfaces/endereco";
import { EquipamentoContrato } from "src/app/modules/painel/modules/contratos/interfaces/equipamento-contrato";
import { Equipamento } from "src/app/modules/painel/modules/equipamentos/interfaces/equipamento";
import { Ocorrencia } from "src/app/modules/painel/modules/ocorrencias/interfaces/ocorrencia";
import { Prestador } from "src/app/modules/painel/modules/prestadores/interfaces/prestador";

export class Utils {

  constructor() { }

  customSearchPrestador = (term: string, item: Prestador) => {
    term = term.toLocaleLowerCase().replace(/[/\.-]/g, "");
    return (item.nome && item.nome.toLocaleLowerCase().includes(term)) ||
      (item.cnpj && item.cnpj.toLocaleLowerCase().replace(/[/\.-]/g, "").includes(term));
  }

  customSearchCliente = (term: string, item: Cliente) => {
    term = term.toLocaleLowerCase().replace(/[/\.-]/g, "");
    return (item.nome_fantasia && item.nome_fantasia.toLocaleLowerCase().includes(term)) ||
      (item.razao_social && item.razao_social.toLocaleLowerCase().replace(/[/\.-]/g, "").includes(term)) ||
      (item.cnpj && item.cnpj.toLocaleLowerCase().replace(/[/\.-]/g, "").includes(term)) ||
      (item.codigo && item.codigo.toLocaleLowerCase().replace(/[/\.-]/g, "").includes(term));
  }

  customSearchEndereco = (term: string, item: Endereco) => {
    term = term.toLocaleLowerCase().replace(/[/\.-]/g, "");
    return (item.identificacao && item.identificacao.toLocaleLowerCase().includes(term)) ||
      (item.logradouro && item.logradouro.toLocaleLowerCase().includes(term)) ||
      (item.numero && item.numero.toLocaleLowerCase().includes(term)) ||
      (item.cidade && item.cidade.toLocaleLowerCase().includes(term)) ||
      (item.uf && item.uf.toLocaleLowerCase().includes(term));
  }

  customSearchOcorrencia = (term: string, item: Ocorrencia) => {
    term = term.toLocaleLowerCase().replace(/[/\.-]/g, "");
    return (item.nome && item.nome.toLocaleLowerCase().includes(term));
  }

  customSearchEquipamento = (term: string, item: Equipamento) => {
    term = term.toLocaleLowerCase().replace(/[/\.-]/g, "");
    return (item.nome && item.nome.toLocaleLowerCase().includes(term)) ||
      (item.descricao && item.descricao.toLocaleLowerCase().includes(term));
  }

  customSearchEquipamentoContrato = (term: string, item: EquipamentoContrato) => {
    term = term.toLocaleLowerCase().replace(/[/\.-]/g, "");
    return (item.nomeEquipamento && item.nomeEquipamento.toLocaleLowerCase().includes(term)) ||
      (item.localizacao && item.localizacao.toLocaleLowerCase().includes(term)) ||
      (item.numero_serie && item.numero_serie.toLocaleLowerCase().includes(term));
  }

  customSearchUsuario = (term: string, item: Prestador) => {
    term = term.toLocaleLowerCase().replace(/[/\.-]/g, "");
    return (item.nome && item.nome.toLocaleLowerCase().includes(term)) ||
      (item.email && item.email.toLocaleLowerCase().replace(/[/\.-]/g, "").includes(term));
  }

  cpfMask = (documento: string) => {
    if (!documento)
      return '0*';

    return '000.000.000-009';
  }

  cnpjMask = (documento: string) => {
    if (!documento)
      return '0*';

    return '00.000.000/0000-00';
  }

  cpfCnpjMask = (documento: string) => {
    if (!documento)
      return '0*';

    if (documento.length <= 11)
      return '000.000.000-009';
    else
      return '00.000.000/0000-00';
  }

  cpfValidator = (cpf: AbstractControl) => {
    if (!cpf.value)
      return { invalid: true };

    const cpfStr = cpf.value.replace(/[^\d]+/g, '');

    if (cpfStr === '') return { invalid: true };

    if (cpfStr.length !== 11)
      return { invalid: true };

    if (cpfStr === "00000000000" ||
      cpfStr === "11111111111" ||
      cpfStr === "22222222222" ||
      cpfStr === "33333333333" ||
      cpfStr === "44444444444" ||
      cpfStr === "55555555555" ||
      cpfStr === "66666666666" ||
      cpfStr === "77777777777" ||
      cpfStr === "88888888888" ||
      cpfStr === "99999999999")
      return { invalid: true };

    var soma: number;
    var resto: number;

    soma = 0;

    for (let i = 1; i <= 9; i++)
      soma += parseInt(cpfStr.substring(i - 1, i)) * (11 - i);

    resto = (soma * 10) % 11;

    if ((resto == 10) || (resto == 11)) resto = 0;

    if (resto != parseInt(cpfStr.substring(9, 10))) return { invalid: true };

    soma = 0;

    for (let i = 1; i <= 10; i++)
      soma += parseInt(cpfStr.substring(i - 1, i)) * (12 - i);

    resto = (soma * 10) % 11;

    if ((resto == 10) || (resto == 11)) resto = 0;

    if (resto != parseInt(cpfStr.substring(10, 11))) return { invalid: true };

    return null;
  }

  cnpjValidator = (cnpj: AbstractControl) => {
    if (!cnpj.value)
      return { invalid: true };

    const cnpjStr = cnpj.value.replace(/[^\d]+/g, '');

    if (cnpjStr === '') return { invalid: true };

    if (cnpjStr.length !== 14)
      return { invalid: true };

    if (cnpjStr === "00000000000000" ||
      cnpjStr === "11111111111111" ||
      cnpjStr === "22222222222222" ||
      cnpjStr === "33333333333333" ||
      cnpjStr === "44444444444444" ||
      cnpjStr === "55555555555555" ||
      cnpjStr === "66666666666666" ||
      cnpjStr === "77777777777777" ||
      cnpjStr === "88888888888888" ||
      cnpjStr === "99999999999999")
      return { invalid: true };

    var tamanho: number = cnpjStr.length - 2
    const digitos: string = cnpjStr.substring(tamanho);
    var numeros: string = cnpjStr.substring(0, tamanho);
    var soma = 0;
    var pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(numeros.charAt(tamanho - i)) * pos--;

      if (pos < 2)
        pos = 9;
    }

    var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

    if (resultado !== parseInt(digitos.charAt(0)))
      return { invalid: true };

    tamanho = tamanho + 1;
    numeros = cnpjStr.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2)
        pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

    if (resultado !== parseInt(digitos.charAt(1)))
      return { invalid: true };

    return null;
  }

  cpfCnpjValidator = (documento: AbstractControl) => {
    if (this.cpfValidator(documento) === null || this.cnpjValidator(documento) === null)
      return null;
    else
      return { invalid: true };
  }

  passwordPattern() {
    return new RegExp(/^.*(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[\d\x])(?=.*[!$#%@]).*$/g);
  }

  passwordsValidate = (formGroup: FormGroup) => {
    const pass = formGroup.get('password').value;
    const confirmPass = formGroup.get('password_confirmation').value;

    if (pass !== confirmPass) {
      formGroup.controls.password_confirmation.setErrors({ notSame: true });
    }

    return pass === confirmPass ? null : { notSame: true };
  }

  passwordPatternValidate = (passwordCtrl: AbstractControl) => {
    const password = passwordCtrl.value;

    const minLenRegex = new RegExp(/^.*(?=.{8,}).*$/g);
    const minusculasRegex = new RegExp(/^.*(?=.*[a-z]).*$/g);
    const maiusculasRegex = new RegExp(/^.*(?=.*[A-Z]).*$/g);
    const digitosRegex = new RegExp(/^.*(?=.*[\d\x]).*$/g);
    const characEspRegex = new RegExp(/^.*(?=.*[!$#%@]).*$/g);

    if (!minLenRegex.test(password))
      return { invalidPassword: 'A senha deve conter no mínimo 8 caracteres' };

    if (!minusculasRegex.test(password))
      return { invalidPassword: 'A senha deve conter no mínimo 1 caractere minúsculo' };

    if (!maiusculasRegex.test(password))
      return { invalidPassword: 'A senha deve conter no mínimo 1 caractere maiúsculo' };

    if (!digitosRegex.test(password))
      return { invalidPassword: 'A senha deve conter no mínimo 1 dígito' };

    if (!characEspRegex.test(password))
      return { invalidPassword: 'A senha deve conter no mínimo 1 caractere especial' };

    return null;
  }

  formatarString(string: string = '') {
    const regexSC = /[´`\[\{\]\}~^,<\.>;:'"!@#$%¨&\*\(\)\=\+\/\?\-\\]/g;
    const regexCedilha = /[çÇ]/g;
    const regexA = /[(áàãâä)]/g;
    const regexE = /[éèêë]/g;
    const regexI = /[íìîï]/g;
    const regexO = /[óòõôö]/g;
    const regexU = /[úùûü]/g;

    string = string.toLowerCase();

    string = string.replace(regexSC, '')
      .replace(regexCedilha, 'c')
      .replace(regexA, 'a')
      .replace(regexE, 'e')
      .replace(regexI, 'i')
      .replace(regexO, 'o')
      .replace(regexU, 'u')
      .replace(/\s/g, '_');

    return string;
  }

  clone(item: any) {
    return JSON.parse(JSON.stringify(item));
  }

  filterDistinctById<T>(array: any[]) {
    const resultado: T[] = [];
    const map = new Map();

    for (const item of array) {
      if (!map.has(item.id)) {
        map.set(item.id, true);
        resultado.push(item);
      }
    }

    return resultado;
  }

  coresPadrao() {
    return [
      { nome: 'Amarelo', valor: 'yellow' },
      { nome: 'Laranja', valor: 'orange' },
      { nome: 'Vermelho', valor: 'red' },
      { nome: 'Azul', valor: 'blue' },
      { nome: 'Verde', valor: 'green' },
      { nome: 'Roxo', valor: 'purple' },
      { nome: 'Rosa', valor: 'pink' },
      { nome: 'Preto', valor: 'black' }
    ];
  }

  getDiasDoMes() {
    const dias = [];

    for (let i = 1; i <= 31; i++) {
      const dia = {
        text: '',
        value: null
      }

      dia.text = `${i}`;
      dia.value = i;
      dias.push(dia);
    }

    return dias;
  }

  getMeses() {
    return [
      { value: 1, text: 'Janeiro' },
      { value: 2, text: 'Fevereiro' },
      { value: 3, text: 'Março' },
      { value: 4, text: 'Abril' },
      { value: 5, text: 'Maio' },
      { value: 6, text: 'Junho' },
      { value: 7, text: 'Julho' },
      { value: 8, text: 'Agosto' },
      { value: 9, text: 'Setembro' },
      { value: 10, text: 'Outubro' },
      { value: 11, text: 'Novembro' },
      { value: 12, text: 'Dezembro' }
    ];
  }

  getDiasSemana() {
    return [
      { id: 0, tx: 'Domingos e Feriados' },
      { id: 1, tx: 'Segunda-feira' },
      { id: 2, tx: 'Terça-feira' },
      { id: 3, tx: 'Quarta-feira' },
      { id: 4, tx: 'Quinta-feira' },
      { id: 5, tx: 'Sexta-feira' },
      { id: 6, tx: 'Sábado' }
    ];
  }

  getEstados() {
    return [
      { key: 'AC', value: 'Acre' },
      { key: 'AL', value: 'Alagoas' },
      { key: 'AP', value: 'Amapá' },
      { key: 'AM', value: 'Amazonas' },
      { key: 'BA', value: 'Bahia' },
      { key: 'CE', value: 'Ceará' },
      { key: 'DF', value: 'Distrito Federal' },
      { key: 'ES', value: 'Espírito Santo' },
      { key: 'GO', value: 'Goiás' },
      { key: 'MA', value: 'Maranhão' },
      { key: 'MT', value: 'Mato Grosso' },
      { key: 'MS', value: 'Mato Grosso do Sul' },
      { key: 'MG', value: 'Minas Gerais' },
      { key: 'PA', value: 'Pará' },
      { key: 'PB', value: 'Paraíba' },
      { key: 'PR', value: 'Paraná' },
      { key: 'PE', value: 'Pernambuco' },
      { key: 'PI', value: 'Piauí' },
      { key: 'RJ', value: 'Rio de Janeiro' },
      { key: 'RN', value: 'Rio Grande do Norte' },
      { key: 'RS', value: 'Rio Grande do Sul' },
      { key: 'RO', value: 'Rondônia' },
      { key: 'RR', value: 'Roraima' },
      { key: 'SC', value: 'Santa Catarina' },
      { key: 'SP', value: 'São Paulo' },
      { key: 'SE', value: 'Sergipe' },
      { key: 'TO', value: 'Tocantins' }
    ];
  }

  random(min: number, max: number) {
    return Math.random() * (max - min) + min;
  }

  copyToClipboard(texto: string) {
    return navigator.clipboard.writeText(texto);
  }

  async fileToBase64(file: File): Promise<string> {
    return await new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        resolve(reader.result as string);
      };

      reader.onerror = (error) => {
        reject(error);
      };
    })
  }

  delayMs(ms: number) {
    return new Promise<void>(resolve => setTimeout(() => resolve(), ms));
  }
}